import React from 'react';
import { Button } from '../ui/Button';
import { PriceDisplay } from '../ui/PriceDisplay';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function Pricing() {
  return <section className="py-10 px-4 bg-cream" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <div className="text-center mb-6" data-id="element-136">
          <h2 className="text-4xl md:text-5xl font-black text-forest-green mb-3 font-serif" data-id="element-137">
            Entonces, ¿Cuánto Vale Todo Esto?
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 max-w-2xl mx-auto leading-relaxed mb-2 font-bold" data-id="element-138">
            Pensalo así: si cada bolsa de alimento "premium" te cuesta entre
            $15.000 y $25.000 por mes... este sistema se paga solo en las
            primeras 2 semanas de ahorro.
          </p>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-139">
            Si contrataras una consulta con un nutricionista veterinario
            especializado, pagarías entre $8.000 y $15.000 por una sola sesión.
            Este sistema es como tener esas consultas infinitas.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-gold" data-id="element-140">
          {/* Value Stack */}
          <div className="p-5 md:p-6 bg-white" data-id="element-141">
            <h3 className="text-3xl font-black text-center mb-4 text-forest-green font-serif" data-id="element-142">
              Lo que te llevás hoy:
            </h3>

            <ul className="border-2 border-gray-100 rounded-xl overflow-hidden text-base md:text-lg shadow-sm" data-id="element-143">
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-gray-50 border-b border-gray-200 gap-1 md:gap-0" data-id="element-144">
                <span className="font-black text-gray-900" data-id="element-145">
                  Sistema Alimenta Con Amor (200+ recetas + protocolos)
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-146">
                  Valor <PriceDisplay type="system" data-id="element-147" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-white border-b border-gray-200 gap-1 md:gap-0" data-id="element-148">
                <span className="font-black text-gray-900" data-id="element-149">
                  Protocolo de Transición de 20 Días
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-150">
                  Valor <PriceDisplay type="protocol" data-id="element-151" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-gray-50 border-b border-gray-200 gap-1 md:gap-0" data-id="element-152">
                <span className="font-black text-gray-900" data-id="element-153">
                  Guía de Alimentos Permitidos y Prohibidos
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-154">
                  Valor <PriceDisplay type="guide" data-id="element-155" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-white border-b border-gray-200 gap-1 md:gap-0" data-id="element-156">
                <span className="font-black text-gray-900" data-id="element-157">
                  Planes Para Condiciones Especiales
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-158">
                  Valor <PriceDisplay type="plans" data-id="element-159" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-green-50 border-b border-green-100 gap-1 md:gap-0" data-id="element-160">
                <span className="font-black text-green-800 flex items-center gap-2" data-id="element-161">
                  <span className="text-xl" data-id="element-162">🎁</span> BONO #1: Recetario de
                  Snacks Saludables
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-163">
                  Valor <PriceDisplay type="b1" data-id="element-164" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-green-100/50 border-b border-green-100 gap-1 md:gap-0" data-id="element-165">
                <span className="font-black text-green-800 flex items-center gap-2" data-id="element-166">
                  <span className="text-xl" data-id="element-167">🎁</span> BONO #2: Guía de Primeros
                  Auxilios Nutricionales
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-168">
                  Valor <PriceDisplay type="b2" data-id="element-169" />
                </span>
              </li>
              <li className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-green-50 gap-1 md:gap-0" data-id="element-170">
                <span className="font-black text-green-800 flex items-center gap-2" data-id="element-171">
                  <span className="text-xl" data-id="element-172">🎁</span> BONO #3: Grupo Privado de
                  Por Vida
                </span>
                <span className="text-gray-500 font-bold whitespace-nowrap" data-id="element-173">
                  Valor <PriceDisplay type="b3" data-id="element-174" />
                </span>
              </li>
            </ul>

            {/* VALOR TOTAL */}
            <div className="mt-5 bg-gray-900 rounded-2xl p-5 md:p-6 text-center shadow-xl border-b-4 border-gray-800" data-id="element-175">
              <p className="text-base md:text-lg uppercase tracking-[0.2em] text-gold font-black mb-1" data-id="element-176">
                Valor Total
              </p>
              <span className="text-4xl md:text-5xl font-black text-white line-through decoration-danger decoration-[4px] opacity-90" data-id="element-177">
                <PriceDisplay type="total" showCurrencyCode data-id="element-178" />
              </span>
            </div>
          </div>

          {/* Oferta de lanzamiento banner */}
          <div className="bg-danger px-6 py-5 flex items-center justify-center gap-3 shadow-inner" data-id="element-179">
            <Zap className="w-7 h-7 text-gold fill-gold animate-pulse" data-id="element-180" />
            <span className="text-white font-black text-xl md:text-3xl uppercase tracking-widest" data-id="element-181">
              Oferta de lanzamiento
            </span>
            <Zap className="w-7 h-7 text-gold fill-gold animate-pulse" data-id="element-182" />
          </div>

          {/* Offer Area */}
          <div className="p-6 md:p-8 text-center bg-forest-green text-white relative overflow-hidden" data-id="element-183">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(212,160,23,0.3)_0%,transparent_70%)] pointer-events-none" data-id="element-184"></div>

            <p className="text-xl md:text-2xl text-gold-light mb-1 relative z-10 font-bold" data-id="element-185">
              Precio regular:{' '}
              <span className="line-through decoration-[3px] decoration-danger" data-id="element-186">
                <PriceDisplay type="regular" data-id="element-187" />
              </span>
            </p>

            <div className="flex justify-center items-baseline gap-2 mb-1 relative z-10" data-id="element-188">
              <span className="text-[5rem] md:text-[8rem] font-black text-gold font-serif drop-shadow-[0_0_30px_rgba(212,160,23,0.5)] leading-none tracking-tighter" data-id="element-189">
                <PriceDisplay type="offer" data-id="element-190" />
              </span>
            </div>

            <p className="text-lg md:text-xl font-black mb-5 text-cream relative z-10 tracking-wide uppercase bg-white/10 inline-block px-6 py-2 rounded-full border border-white/20" data-id="element-191">
              Pago único · Sin costos mensuales
            </p>

            <div className="relative z-10 w-full max-w-xl mx-auto" data-id="element-192">
              <Button fullWidth className="w-full text-xl md:text-3xl py-6 md:py-8 mb-4 shadow-[0_0_40px_rgba(212,160,23,0.6)]" data-id="element-193">
                ▶ QUIERO TRANSFORMAR A MI MASCOTA AHORA →
              </Button>
            </div>

            <p className="text-base text-cream/80 mb-4 italic relative z-10 font-bold" data-id="element-194">
              Me reservo el derecho de cerrar esta oferta sin previo aviso
            </p>

            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm md:text-base text-cream font-bold relative z-10 bg-black/20 py-4 px-6 rounded-xl border border-white/10" data-id="element-195">
              <div className="flex items-center gap-2" data-id="element-196">
                <ShieldCheck className="w-5 h-5 text-gold" data-id="element-197" />
                <span data-id="element-198">Compra única</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-199">
                <Lock className="w-5 h-5 text-gold" data-id="element-200" />
                <span data-id="element-201">Sin cuotas mensuales</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-202">
                <CreditCard className="w-5 h-5 text-gold" data-id="element-203" />
                <span data-id="element-204">Acceso inmediato digital</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}